// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;119</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;Blessed are those whose way is pure,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;who walk in the law of the Lord.<br> </p> </div></div>";
// Exports
module.exports = code;